import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { ProductVisibilityTypeEnum } from 'app/back-office/shared/enum/products-visibility-type.enum.model';
import { ProductsService } from 'app/back-office/shared/services/back-office/products.service';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { LoaderService } from 'app/shared/services/loader.service';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-assortment-filter',
    templateUrl: './assortment-filter.component.html',
    styleUrls: ['./assortment-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssortmentFilterComponent implements OnInit, OnChanges {
  @Input() filter: InternalFilterGroup;
  @Input() accordionState: boolean;

  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search assortment...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [];
  constructor(private productService: ProductsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.accordionState && this.accordionState && this.dataToView.length === 0) {
      this.setDataToView(0);
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.searchValue = search;
    this.setDataToView(0);
  }

  setDataToView(skipCount: number) {
    this.productService.getAssortments({ skipCount, maxResultCount: 20, search: this.searchValue, loaderId: this.loaderId }).subscribe(res => {
      this.dataToView = res.items.map(el => FilterMapper.assortmentFilter(el));
      this.totalCount = res.totalCount;
    });
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      const next = skipCount;
      this.setDataToView(next);
    }
  }

}
